function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#979797",
  d: "M17.389 8.771c-.025-.055-.62-1.376-1.944-2.7C13.68 4.307 11.452 3.374 9 3.374c-2.452 0-4.681.933-6.445 2.697C1.231 7.395.635 8.716.611 8.77c-.032.072-.048.15-.048.229 0 .079.016.156.048.228.025.056.62 1.377 1.944 2.7C4.32 13.693 6.548 14.625 9 14.625c2.452 0 4.68-.932 6.445-2.695 1.324-1.324 1.92-2.645 1.944-2.7.032-.073.049-.15.049-.23 0-.078-.017-.156-.049-.228zM9 6.47c.5 0 .99.148 1.406.426.416.278.741.674.933 1.136.191.463.241.972.144 1.463-.098.49-.34.942-.693 1.296-.354.354-.805.595-1.296.693-.491.097-1 .047-1.463-.144-.462-.192-.858-.516-1.136-.933C6.617 9.99 6.47 9.501 6.47 9c0-.671.267-1.314.742-1.789.474-.475 1.118-.741 1.789-.742z"
});

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.57fe92b0.svg";
export { ForwardRef as ReactComponent };